/**
 * @file index.tsx
 *
 * @fileoverview Map container that only renders the map if we are on the client side
 * and there are some markers to display.
 */
import dynamic from 'next/dynamic';
import { MapLeafletMapProps } from '~/jobiqo/components/Map/LeafletMap';

const LeafletMap = dynamic(() => import('~/jobiqo/components/Map/LeafletMap'), {
  ssr: false,
});

export const Map = ({ markers }: MapLeafletMapProps) => {
  return markers.length > 0 ? <LeafletMap markers={markers} /> : null;
};
export default Map;
